import { render, staticRenderFns } from "./CardCancelarPlano.vue?vue&type=template&id=19f6a934&scoped=true"
import script from "./CardCancelarPlano.vue?vue&type=script&lang=js"
export * from "./CardCancelarPlano.vue?vue&type=script&lang=js"
import style0 from "./CardCancelarPlano.vue?vue&type=style&index=0&id=19f6a934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6a934",
  null
  
)

export default component.exports